import { SHOPIFY_CHECKOUT_ID_COOKIE } from './const'
import { SHOPIFY_CART_ID_COOKIE } from './const'

import { handler as useActualCart } from './actual-cart/use-cart'
import { handler as useAddLine } from './actual-cart/use-add-line'
import { handler as useUpdateDiscount } from './actual-cart/use-update-discount'
import { handler as useUpdateLine } from './actual-cart/use-update-line'
import { handler as useRemoveLine } from './actual-cart/use-remove-line'
import { handler as useCart } from './cart/use-cart'
import { handler as useAddItem } from './cart/use-add-item'
import { handler as useUpdateItem } from './cart/use-update-item'
import { handler as useRemoveItem } from './cart/use-remove-item'
import { handler as useApplyDiscount } from './cart/use-apply-discount'

import { handler as useCustomer } from './customer/use-customer'
import { handler as useSearch } from './product/use-search'

import useLogin from './auth/use-login'
import { handler as useLogout } from './auth/use-logout'
import { handler as useSignup } from './auth/use-signup'
import { handler as useForgotPassword } from './auth/use-forgotPassword'
import { handler as useActivate } from './auth/use-activate'
import { handler as useSetNewPassword } from './auth/use-setNewPassword'

import fetcher from './fetcher'

export const shopifyProvider = {
  locale: 'en-us',
  cartCookie: SHOPIFY_CHECKOUT_ID_COOKIE,
  actualCartCookie: SHOPIFY_CART_ID_COOKIE,
  fetcher,
  actualCart: { useCart: useActualCart, useUpdateDiscount,  useAddLine, useUpdateLine, useRemoveLine },
  cart: { useCart, useAddItem, useUpdateItem, useRemoveItem, useApplyDiscount },
  customer: { useCustomer },
  products: { useSearch },
  auth: { useLogin: useLogin as any, useLogout, useSignup, useForgotPassword, useActivate, useSetNewPassword },
}


export type ShopifyProvider = typeof shopifyProvider
